module.exports = __webpack_public_path__ + "static/media/manage_active.76832121.svg";